"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.paymentsReducerFunction = exports.paymentsActions = exports.paymentState = exports.initialState = void 0;
var immer_reducer_1 = require("immer-reducer");
var payment_1 = __importDefault(require("../models/payment"));
exports.initialState = {
    data: null,
    loading: false,
    success: false,
    loaded: false,
    paymentHtmlPage: null,
    errorMessage: "",
    nextPayment: null,
    PaymentFailureErrorType: null,
    paymentsHistory: []
};
var paymentState = /** @class */ (function (_super) {
    __extends(paymentState, _super);
    function paymentState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    paymentState.prototype.reset = function () {
        this.draftState = exports.initialState;
    };
    paymentState.prototype.fetchPayments = function (customerAccountId) {
        this.draftState.loading = true;
    };
    paymentState.prototype.fetchPaymentsSuccess = function (payment) {
        this.draftState.loading = false;
        this.draftState.loaded = true;
        this.draftState.data = payment;
    };
    paymentState.prototype.fetchPaymentsFailure = function (errorMsg) {
        this.draftState.loading = false;
        if (errorMsg) {
            this.draftState.errorMessage = errorMsg;
        }
    };
    paymentState.prototype.fetchPaymentsHistory = function (customerAccountId, startDateDay, startDateMonth, startDateYear, endDateDay, endDateMonth, endDateYear) {
        this.draftState.loading = true;
    };
    paymentState.prototype.fetchPaymentsHistorySuccess = function (paymentsHistory) {
        this.draftState.loading = false;
        this.draftState.loaded = true;
        this.draftState.paymentsHistory = paymentsHistory;
    };
    paymentState.prototype.fetchPaymentsHistoryFailure = function (errorMsg) {
        this.draftState.loading = false;
        if (errorMsg) {
            this.draftState.errorMessage = errorMsg;
        }
    };
    paymentState.prototype.addPayment = function (newPayment) {
        this.draftState.data[newPayment.periodicDebitSchedulerId] = new payment_1.default(newPayment);
    };
    paymentState.prototype.deletePayment = function (id) {
        delete this.draftState.data[id];
    };
    paymentState.prototype.resetPaymentStatus = function () {
        this.draftState.loading = false;
        this.draftState.loaded = false;
        this.draftState.paymentHtmlPage = null;
        this.draftState.errorMessage = null;
    };
    paymentState.prototype.processPayment = function (payload) {
        this.draftState.loading = true;
        this.draftState.loaded = false;
        this.draftState.paymentHtmlPage = null;
        this.draftState.errorMessage = null;
        this.draftState.PaymentFailureErrorType = null;
    };
    paymentState.prototype.processPaymentSuccess = function (paymentHtmlPage) {
        this.draftState.loading = false;
        this.draftState.loaded = true;
        this.draftState.paymentHtmlPage = paymentHtmlPage;
        this.draftState.errorMessage = null;
        this.draftState.PaymentFailureErrorType = null;
    };
    paymentState.prototype.processPaymentFailure = function (errorMsg, errorType) {
        this.draftState.loading = false;
        this.draftState.loaded = false;
        this.draftState.paymentHtmlPage = null;
        this.draftState.errorMessage = errorMsg;
        this.draftState.PaymentFailureErrorType = errorType;
    };
    // "updatedirectdebitOptions" this action will modify the user's direct debit preferences such as the day of the direct debit as well as its amount.
    paymentState.prototype.updatedirectdebitOptions = function (_payload) {
        this.draftState.loading = true;
        this.draftState.loaded = false;
        this.draftState.errorMessage = null;
        this.draftState.nextPayment = null;
    };
    paymentState.prototype.updatedirectdebitOptionsSuccess = function (payment) {
        this.draftState.loading = false;
        this.draftState.loaded = true;
        this.draftState.nextPayment = payment;
    };
    // the error is not send to the state directly
    paymentState.prototype.updatedirectdebitOptionsError = function (errorMsg) {
        this.draftState.loading = false;
        this.draftState.loaded = false;
        this.draftState.nextPayment = null;
    };
    // "isUpdatabledirectdebitOptions" this action will check if the user can update his direct debit options.
    paymentState.prototype.isUpdatableDirectDebitOptions = function (customerAccountId) {
        this.draftState.loading = true;
        this.draftState.loaded = false;
        this.draftState.errorMessage = null;
    };
    paymentState.prototype.isUpdatableDirectDebitOptionsSuccess = function () {
        this.draftState.loading = false;
        this.draftState.loaded = true;
    };
    // the error is not send to the state directly
    paymentState.prototype.isUpdatableDirectDebitOptionsFailure = function (errorMsg) {
        this.draftState.loading = false;
        this.draftState.loaded = false;
        this.draftState.errorMessage = errorMsg;
    };
    return paymentState;
}(immer_reducer_1.ImmerReducer));
exports.paymentState = paymentState;
exports.paymentsActions = (0, immer_reducer_1.createActionCreators)(paymentState);
exports.paymentsReducerFunction = (0, immer_reducer_1.createReducerFunction)(paymentState, exports.initialState);
